import { FormControl, MenuItem, Select } from "@material-ui/core";
import { useEffect, useState } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useStyles } from "./dropDown.styles";

export interface IDropDownOption {
  value: string;
  label: string;
}
interface IDropDownProps {
  placeholder?: string;
  menuItems: { value: string; label: string }[];
  setValueFunc: (value: string) => void;
  ellipsisSize?: number;
}

const DropDown = (props: IDropDownProps) => {
  const { menuItems, setValueFunc, ellipsisSize, placeholder } = props;
  const [item, setItem] = useState<{ value: string; label: string } | undefined>(undefined);
  const classes = useStyles(!!ellipsisSize)();

  const handleChange = (event: any) => {
    const value = event.target.value;
    const selected = menuItems.find((item) => item.value === value);
    setItem(selected);
    setValueFunc(value);
  };

  const getEllipsisText = (text: string) => {
    const size = ellipsisSize || 50;
    const maxSize = size - 10;
    if (text.length > size) {
      return (
        text.substring(0, maxSize) +
        "..." +
        text.substring(text.length - 10, text.length)
      );
    }
    return text;
  };

  return (
    <FormControl className={classes.textField} variant="filled">
      <Select
        labelId="select-label"
        value={item ? item.value : ""}
        label={item ? item.label : ""}
        className={classes.select}
        IconComponent={ExpandMoreIcon}
        disableUnderline
        onChange={handleChange}
        displayEmpty
      >
        <MenuItem value="" disabled className={classes.menuItem}>
          {placeholder || "Select..."}
        </MenuItem>
        {menuItems.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            className={classes.menuItem}
          >
            {getEllipsisText(item.label)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropDown;
